import React, { useState } from "react"
import {
    Checkbox,
    View,
    Flex,
    Text as SpectrumText,
} from "@adobe/react-spectrum"
import styles from "./AddAlert.module.css"

const SubTypes = ({ state, updateAbandonedState }) => {
    // console.log("state", state)
    return (
        <View padding={"0 0 0 3rem"}>
            <SpectrumText UNSAFE_className={styles.label} marginBottom={"5px"}>
                Alert Sub Types
            </SpectrumText>
            <Flex direction="row" gap="size-200" alignItems="center">
                <View marginStart={"2rem"}>
                    <Checkbox
                        isSelected={state?.scheduled}
                        onChange={() =>
                            updateAbandonedState(
                                {
                                    ...state,
                                    scheduled: !state.scheduled
                                }
                            )
                        }
                    >
                        <SpectrumText UNSAFE_className={styles.checkbox}>
                            Scheduled
                        </SpectrumText>
                    </Checkbox>
                    <Checkbox
                        isSelected={state?.rescheduled}
                        onChange={() =>
                            updateAbandonedState({
                                ...state,
                                rescheduled: !state.rescheduled
                            })
                        }
                    >
                        <SpectrumText UNSAFE_className={styles.checkbox}>
                            Re-Scheduled
                        </SpectrumText>
                    </Checkbox>
                    <Checkbox
                        isSelected={state?.cancelled}
                        onChange={() =>
                            updateAbandonedState({
                                ...state,
                                cancelled: !state.cancelled
                            })
                        }
                    >
                        <SpectrumText UNSAFE_className={styles.checkbox}>
                            Cancelled
                        </SpectrumText>
                    </Checkbox>
                    <Checkbox
                        isSelected={state?.reassigned}
                        onChange={() =>
                            updateAbandonedState({
                                ...state,
                                reassigned: !state.reassigned
                            })
                        }
                    >
                        <SpectrumText UNSAFE_className={styles.checkbox}>
                            Re-Assigned
                        </SpectrumText>
                    </Checkbox>
                </View>
            </Flex>
        </View>
    )
}

export default SubTypes
